import {ICommonTableConfig, ICommonTableService} from '@lib-ui/common-table/models/common-table.interface';
import {BehaviorSubject} from 'rxjs';
import {CommonTableData} from '@lib-ui/common-table/models/common-table-data.class';
import {Injectable, signal} from '@angular/core';
import {CategoryService} from '@lib-services/category.service';
import {MessageService} from '@lib-services/message.service';
import {Params} from '@angular/router';
import {IPaginatedResponse} from '@lib-typing/response.interface';
import {ICategory, ICategoryTableData} from '@lib-typing/category.interface';

@Injectable({
    providedIn: 'root',
})
export class CategoryTableService implements ICommonTableService<ICategoryTableData> {
    public tableData$: BehaviorSubject<CommonTableData<ICategoryTableData>> = new BehaviorSubject<CommonTableData<ICategoryTableData>>(new CommonTableData());
    defaultFilterParams = {
        sortBy: 'createdAt:DESC',
    };
    private readonly commonTableData = new CommonTableData();
    loading = signal<boolean>(false);

    constructor(private categoryService: CategoryService, private messageService: MessageService) {}

    updateData(config: ICommonTableConfig): void {
        this.loading.set(true);
        this.categoryService
            .getCategories(this.createSearchParams(config))
            .subscribe({
                next: response => {
                    this.tableData$.next(new CommonTableData(this.transformData(response)));
                },
                error: () => this.messageService.errorMessage('Ошибка загрузки списка'),
            })
            .add(() => this.loading.set(false));
    }

    createSearchParams(config: ICommonTableConfig): Params {
        this.commonTableData.data.length = 0;
        const { pageIndex, itemsPerPage } = config.paginatorConfig;
        const { filters } = config;

        let searchParams: Params = {
            ...this.defaultFilterParams,
            limit: itemsPerPage.toString(),
        };

        if (pageIndex) {
            searchParams = {
                ...searchParams,
                page: pageIndex.toString(),
            };
        }

        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
                if (value) {
                    let filterValue;

                    switch (key) {
                    case 'name':
                        filterValue = `$ilike:${value}`;
                        break;
                    default:
                        filterValue = `${value}`;
                    }
                    searchParams = {
                        ...searchParams,
                        [`filter.${key}`]: filterValue,
                    };
                }
            });
        }

        return searchParams;
    }

    transformData(response: IPaginatedResponse<ICategory>): IPaginatedResponse<ICategoryTableData> {
        const transformedData = response.data.map(project => {
            return {
                id: project.id,
                createdAt: project.createdAt,
                updatedAt: project.updatedAt,
                name: project.name,
                customId: project.customId,
                equipmentExTableName: project.equipmentExTableName,
                companyName: project.company.name
            } as ICategoryTableData;

        });
        // Return a new response object with transformed data
        return {
            ...response,
            data: transformedData
        };
    }
}
